<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-reserve mypage-title-icon"
    >
        <div class="col-sm-12">
            <div class="my-2">
                <div class="row row-notMx justify-content-between">
                    <div class="specificationTitle">明細書</div>
                    <div class="text-right">No.&nbsp;{{ settle.receipt_no }}<br>発行日&nbsp;{{ settle.receipt_date }}</div>
                </div>
                <div class="row row-notMx">
                    <div class="specificationLabel">ご利用日</div>
                    <div class="specificationText">{{ settle.reserve_date }}</div>
                </div>
                <div class="row row-notMx">
                    <div class="specificationLabel">お客様番号</div>
                    <div class="specificationText">{{ settle.holder_no }}</div>
                </div>
                <div class="row row-notMx">
                    <div class="specificationLabel">顧客名</div>
                    <div class="specificationText">{{ settle.member_name }}&nbsp;&nbsp;様</div>
                </div>
                <div class="row row-notMx">
                    <div class="specificationAmount">{{ settle.receipt_amount }}</div>
                </div>
            </div>
        </div>
        <!--<table class="mx-3 table table-striped specificationTable">-->
        <table class="mx-3 specificationTable table table-striped">
            <!--<thead class="sp_not">-->
                <tr>
                    <th class="text-center" style="width: 60%;" scope="col"><small>項目名</small></th>
                    <th class="text-center min-width-13" style="width: 13%;" scope="col"><small>単価</small></th>
                    <th class="text-center min-width-13" style="width: 13%;" scope="col"><small>数量</small></th>
                    <th class="text-center min-width-13" style="width: 14%;" scope="col"><small>金額</small></th>
                </tr>
            <!--</thead>-->
            <tbody>
                <template v-if="settlesDetails.length === 0">
                    <tr>
                        <td colspan="4" class="text-center">明細はございません。</td>
                    </tr>
                </template>
                <template v-else>
                    <tr style="height: 1.5rem;" v-for="data in settlesDetails" :key="data.item_no">
                        <td>
                            <span><small>{{ data.item_name }}</small></span>
                        </td>
                        <td class="text-right">
                            <span><small>{{ data.unit_price }}</small></span>
                        </td>
                        <td class="text-right">
                            <span><small>{{ data.quantity }}</small></span>
                        </td>
                        <td class="text-right">
                            <span><small>{{ data.line_amount }}</small></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="border: none; background: #eff3f7;" rowspan="2" colspan="2">
                            <span><small>{{ settle.mark_guide }}</small></span>
                        </td>
                        <td class="text-center min-width-20">
                            <span><small>小計</small></span>
                        </td>
                        <td class="text-right">
                            <span><small>{{ settle.subtotal_amount }}</small></span>
                        </td>
                    </tr>
                    <tr>
                        <!-- <td style="border: none; background: #eff3f7;" rowspan="1" colspan="2"></td> -->
                        <td class="text-center min-width-20">
                            <span><small>合計</small></span>
                        </td>
                        <td class="text-right">
                            <span><small>{{ settle.total_amount }}</small></span>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <nav v-if="settlesDetails.length >= 1" aria-label="Page navigation" class="w-100">
            <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item" @click="ClickPagination('Previous')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                </li>
                <li class="pagination-center">
                    <span>{{ pagination }} / {{ maxPaginationNotReturnZero }}</span>
                </li>
                <li class="page-item" @click="ClickPagination('Next')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                </li>
            </ul>
        </nav>
        <!-- 印刷ボタン追加 -->
        <template v-slot:listBackBtn>
            <div class="row row-notMx justify-content-center py-3">
                <button
                    type="button"
                    class="bluebackbutton col-sm-3 mx-3 mb-2"
                    @click="PrintSpecification">
                PDFを送信</button>
                <button
                    class="mypagebackbutton col-sm-3 mx-3"
                    @click="BackResultList">
                一覧へ戻る</button>
            </div>
        </template>
    </Card>
    <MypageMenuFooter/>
    <ConfirmDialog
        v-if="dialog === true"
        :initialMessage="initMessage"
        doing=""
        notDoing="閉じる"
        :processing="processing"
        @closeBtn="addoverlayHidden"
      />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import axios from 'axios';
import { GET_SETTLE_DETAILS, PRINT_SPECIFICATION } from '../../constants/settles';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        ConfirmDialog,
        Card
    },
    data () {
        return {
            // 前ページから受け取る
            settleNo: 1,
            member_no: '',
            page_title: '明細書',
            lineMax: 15,
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // 精算情報
            settle: {},
            // 精算明細情報
            settlesDetails: [],
            // 表示中のページネーション番号
            pagination: 1,
            // 最大ページネーション数(初期表示)
            maxPagination: 1,
            // 確認ダイアログの表示フラグ
            dialog: false,
            initMessage: this.$t("message.printSpecification")

        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            if (sessionStorage.getItem('MyPage.settleNo')) {
                this.settleNo = sessionStorage.getItem('MyPage.settleNo');
            } else {
                this.settleNo = 0;
            }
            this.getSettlesDetails();
        },
        /** ----------------------------------------------
         * 精算情報を取得
         * ---------------------------------------------- */
        getSettlesDetails () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: GET_SETTLE_DETAILS,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo,
                    page_no: this.pagination
                }
            }).then(res => {
                this.settlesDetails = [];
                this.settlesDetails = res.data.GetSettleDetails.SettleDetails;
                this.settle = res.data.GetSettleDetails.Settle;
                // 空行を作成する
                var addLine = this.lineMax - this.settlesDetails.length;
                var itemNum = this.settlesDetails.length + 1;
                for (var i = 0; i < addLine; i++) {
                    var detail = {
                        item_no: itemNum + i,
                        item_name: '',
                        unit_price: '',
                        quantity: '',
                        line_amount: '',
                        detail_type: 0,
                        calc_type: 0,
                        tax_rate: 0
                    }
                    this.settlesDetails.push(detail);
                }
                this.maxPagination = res.data.GetSettleDetails.count;

                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
                this.$store.commit("loading/setIsLoading", false);
            })
        },

        /** ----------------------------------------------
         * 印刷
         * ---------------------------------------------- */
        PrintSpecification: function (){
            this.$store.commit("loading/setIsLoading", true);

            this.$apollo.query({
                query: PRINT_SPECIFICATION,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo,
                    processing_kbn: 1
                }
            }).then(res => {
                if (res.data.PrintSpecification.result == 0) {
                    this.DownloadFile();
                    // 「明細書を作成しました。」
                    // this.$set(this.processing, 'resultText', this.$t("message.printSpecification"));
                    this.$set(this.processing, 'resultText', "ご登録のメールアドレスに送信しました。");
                } else {
                    this.$set(this.processing, 'resultText', this.$t("error.print.specificationNg"));
                }
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.dialog = true;
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.$set(this.processing, 'resultText', error);
                this.dialog = true;
                this.$store.commit("loading/setIsLoading", false);
            })
        },
        /** ----------------------------------------------
         * PDFダウンロード処理
         * ---------------------------------------------- */
        DownloadFile: async function () {
            try {
                // const fileName = {
                //     'fileName': '明細書_' + this.settleNo + '.pdf'
                // };
                // let response = await axios.post('/api/download', fileName, {responseType: 'arraybuffer'});
                // var blob = new Blob([response.data], {type: 'application/pdf'});
                // const link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.setAttribute('download', '明細書.pdf');
                // link.download = fileName['fileName'];
                // link.click();
                // ダウンロード後PDFを削除
                this.DeletePdf();
            } catch (error) {
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.$set(this.processing, 'resultText', error);
                this.dialog = true;
            }

        },
        /** ----------------------------------------------
         * PDFファイル削除処理
         * ---------------------------------------------- */
        DeletePdf: async function () {
            this.$apollo.query({
                query: PRINT_SPECIFICATION,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo,
                    processing_kbn: 2
                }
            }).then(res => {

            }).catch(error => {
                console.log(error);
            })
        },
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        ClickPagination: function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                    this.getSettlesDetails();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.maxPagination) {
                    this.pagination++;
                    this.getSettlesDetails();
                } else {
                    return;
                }
            }
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        addoverlayHidden () {
            this.$set(this.processing, 'result', '');
            this.dialog = false;
        },
        /** ----------------------------------------------
         * 実績一覧へ戻る
         * ---------------------------------------------- */
        BackResultList: function (){
            this.$router.push({ path: '/mypage-result-list' });
        }

    },
    computed: {
        // 小計
        subtotal: function() {
            return this.settlesDetails.reduce((sum, item) => {
                return sum + item.amount;
            }, 0);
        },
        // 消費税
        tax: function() {
          return Math.floor(this.subtotal * 0.1);
        },
        // 合計
        total: function() {
          return Math.floor(this.subtotal * 1.1);
        },
        maxPaginationNotReturnZero () {
            return this.maxPagination === 0 ? 1 : this.maxPagination;
        }
    }
}
</script>

<style scoped>
</style>
